import { render, staticRenderFns } from "./modalAddBrand.vue?vue&type=template&id=5eb8618e&"
import script from "./modalAddBrand.vue?vue&type=script&lang=js&"
export * from "./modalAddBrand.vue?vue&type=script&lang=js&"
import style0 from "./modalAddBrand.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports